<template>
  <section>
    <calendar-settings />
    <template v-if="isCompanyAdmin">
      <coozzy-card
        :title="$t('message.settings.deepsign.title')">
        <div
          v-if="deepsignLoading"
          style="height: 30px">
          <coozzy-spinner />
        </div>
        <div v-else>
          <div
            v-if="deepsignEnabled"
            class="col-12 mt-3">
            <coozzy-alert variant="success">
              {{ $t('message.settings.deepsign.accountLinkedToDeepsign') }}
            </coozzy-alert>
          </div>
          <div
            v-else
            class="col-12 mt-3">
            <coozzy-button
              class="mt-3"
              design="green"
              @click="forwardToDeepsign">
              {{ $t('message.settings.deepsign.linkYourAccount') }}
            </coozzy-button>
          </div>
        </div>
      </coozzy-card>
      <coozzy-card
        v-if="aileanLoading && isCompanyAdmin"
        title="ailean Settings">
        <div style="height: 30px">
          <coozzy-spinner />
        </div>
      </coozzy-card>
      <ailean-settings
        v-if="isCompanyAdmin && !aileanLoading && aileanEnabled"
        class="mt-3"
        :account-id="accountId" />
      <evorest-settings
        v-if="isOwnerModule"
        class="mt-3" />
      <!--
      This export is only for one specific account: Tend AG.
      For testing purposes we also allow 30014 on staging. That account number does not exist on production.
       -->
      <tend-export-settings
        v-if="accountId === 32058 || accountId === 30014"
        class="mt-3" />
    </template>
  </section>
</template>
<script>
import CoozzyCard from '../../framework/components/card/CoozzyCard'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import CoozzyButton from '@/framework/components/button/CoozzyButton'
import DeepsignApi from '@/misc/apis/DeepSignApi'
import { user } from '@/mixins/user'
import CoozzyAlert from '@/framework/components/alert/CoozzyAlert.vue'
import EvorestSettings from '@/settings/components/EvorestSettings.vue'
import { routeChecks } from '@/mixins/routeChecks'
import TendExportSettings from '@/settings/components/TendExportSettings.vue'
import CalendarSettings from '@/settings/components/CalendarSettings.vue'
import AileanSettings from '@/settings/components/AileanSettings.vue'
import AileanApi from '@/misc/apis/AileanApi'

export default {
  name: 'IntegrationsSettings',
  components: {
    CalendarSettings,
    TendExportSettings,
    EvorestSettings,
    CoozzyAlert,
    CoozzyButton,
    CoozzySpinner,
    CoozzyCard,
    AileanSettings
  },
  mixins: [user, routeChecks],
  data() {
    return {
      deepsignLoading: false,
      aileanLoading: false,
      deepsignEnabled: false,
      aileanEnabled: false
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.isCompanyAdmin) {
        return
      }

      // Load DeepSign and AIC status in parallel
      this.loadDeepsignStatus()
      this.loadAileanStatus()
    },
    async loadDeepsignStatus() {
      this.deepsignLoading = true
      try {
        const deepsignResponse = await DeepsignApi.isDeepSignEnabled(this.accountId)
        this.deepsignEnabled = deepsignResponse.enabled
      } catch (error) {
        console.log(error)
      }
      this.deepsignLoading = false
    },
    async loadAileanStatus() {
      this.aileanLoading = true
      try {
        const aileanResponse = await AileanApi.hasAileanEnabled(this.accountId)
        this.aileanEnabled = aileanResponse.enabled
      } catch (error) {
        console.log(error)
      }
      this.aileanLoading = false
    },
    forwardToDeepsign() {
      DeepsignApi.getPartnerAccessUrl(this.accountId).then((response) => {
        window.open(response.url, '_blank')
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>
